import { type FC } from 'react'
import classNames from 'classnames'
import { ONBOARDING_STEP_LABEL, ONBOARDING_STEP_ORDER, OnboardingStep } from './onboardingSteps'
import styles from './OnboardingStepper.module.scss'

export interface OnboardingStepperProps {
  activeStep: OnboardingStep
}

export const OnboardingStepper: FC<OnboardingStepperProps> = ({ activeStep }) => {
  const activeIndex = ONBOARDING_STEP_ORDER.indexOf(activeStep)

  return (
    <ol aria-label='Onboarding steps' className='d-flex align-items-center justify-content-center list-unstyled mb-0 zocks-gap-1.5'>
      {ONBOARDING_STEP_ORDER.map((step, index) => {
        const isCompleted = index < activeIndex
        const isActive = index === activeIndex

        const isPreviousStepCompleted = index - 1 < activeIndex

        return (
          <li key={step} className='d-flex align-items-center zocks-gap-1.5' aria-current={isActive ? 'step' : undefined}>
            {index > 0 ? (
              <div
                aria-hidden='true'
                className={classNames(
                  styles.connector,
                  'border-top flex-shrink-0',
                  isPreviousStepCompleted ? 'zocks-border-color-primary-light' : 'zocks-border-color-gray-300',
                )}
              />
            ) : null}
            <div className='d-flex align-items-center zocks-gap-1'>
              <div
                className={classNames(styles.circle, 'rounded-circle d-flex align-items-center justify-content-center border fw-semibold paragraph-small', {
                  'zocks-bg-color-primary-light zocks-border-color-primary-light zocks-text-primary': isCompleted,
                  'zocks-border-color-primary zocks-text-primary': isActive,
                  'zocks-border-color-gray-300 zocks-text-gray-600': !isCompleted && !isActive,
                })}
              >
                {isCompleted ? <i className='bi bi-check-lg' role='img' aria-label='Completed' /> : index + 1}
              </div>
              <span className={classNames('paragraph-small', isActive ? 'fw-bold text-dark' : 'zocks-text-gray-600')}>{ONBOARDING_STEP_LABEL[step]}</span>
            </div>
          </li>
        )
      })}
    </ol>
  )
}
